import { jsx as t, Fragment as y, jsxs as g } from "react/jsx-runtime";
import { useState as b, useMemo as v, useCallback as k, useLayoutEffect as A } from "react";
import a from "./styles.module.less.js";
import I from "./logo.webp.js";
import { usePathname as N } from "../../../utils/use-pathname.js";
import { AccountLink as C } from "./account-link/index.js";
import { FLOATING_CONTAINER_ID as m } from "./index.js";
import { areasOfLawData as E } from "../../../constants.js";
import { convertToKebabCase as D } from "../../../utils/case-conversion.js";
import { DropdownMenuItemDesktop as M } from "./dropdown-menu-item/index.js";
import { MenuItem as L } from "./menu-item/index.js";
import { ForLawyersMenuButtonDesktop as S } from "./for-lawyers-button/index.js";
import { GetHelpMenuItemDesktop as $ } from "./get-help-menu-item/index.js";
import { MenuChatButtonDesktop as T } from "./chat-button/index.js";
const P = "/help", Q = (s) => {
  const {
    getTranslation: r,
    language: e,
    isLawyerSupported: d = !1,
    lmpEnabled: p = !1
  } = s, n = N(), [l, f] = b(!1), c = v(() => {
    const o = E[e];
    if (o)
      return [
        ...o.map((u) => ({
          ...u,
          path: `/${e}/topics/${D(u.title)}`
        }))
      ];
  }, [e]), i = k(
    (o) => {
      switch (o) {
        case "/chat":
          return n === "/chat";
        case "/about":
          return n === `/${e}/about`;
        case "/about/company":
          return n === `/${e}/about/company`;
        case "/help":
          return n === P;
        case "/find":
          return n === "/find";
        case "/topics":
          return n === `/${e}/topics`;
        case "/account":
          return n === "/account";
        case "/for-lawyers/legal-network":
          return n === `/${e}/for-lawyers/legal-network`;
        default:
          return !1;
      }
    },
    [n, c, e]
  );
  return A(() => {
    const o = () => {
      var h, w;
      (window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0) > 80 ? ((h = document.getElementById(m)) == null || h.classList.add(a.shrink), f(!0)) : ((w = document.getElementById(m)) == null || w.classList.remove(a.shrink), f(!1));
    };
    return window.addEventListener("scroll", o), document.body.addEventListener("scroll", o), o(), () => {
      window.removeEventListener("scroll", o), document.body.removeEventListener("scroll", o);
    };
  }, []), /* @__PURE__ */ t(y, { children: /* @__PURE__ */ t("div", { className: a.floatingContainer, id: m, children: /* @__PURE__ */ g("div", { className: a.menuContentContainer, children: [
    /* @__PURE__ */ t(
      "a",
      {
        href: e ? `/${e}` : "/",
        className: a.logoContainer,
        children: /* @__PURE__ */ t(
          "img",
          {
            src: I,
            alt: "LawConnect Logo",
            width: 0,
            height: 20,
            className: a.logo
          }
        )
      }
    ),
    /* @__PURE__ */ g("div", { className: a.menuLinksContainer, children: [
      d ? /* @__PURE__ */ t(
        $,
        {
          language: e,
          titleLabel: r("pages.get-help"),
          getTranslation: r,
          hasShrunk: l,
          isLawyerSupported: !0,
          onRequestLawyer: s.onRequestLawyer,
          isActive: i(
            "/help"
            /* HELP */
          )
        }
      ) : /* @__PURE__ */ t(
        T,
        {
          getTranslation: r,
          isScrolledHeader: l
        }
      ),
      d ? null : /* @__PURE__ */ t("div", { className: a.spacer }),
      p ? /* @__PURE__ */ t(
        L,
        {
          label: "Browse lawyers",
          path: "/find",
          hasShrunk: l,
          isActive: i(
            "/find"
            /* BROWSE_LAWYERS */
          )
        }
      ) : null,
      c ? /* @__PURE__ */ t(
        M,
        {
          language: e,
          items: c,
          titleLabel: r("pages.legal-topics"),
          hasShrunk: l,
          link: `/${e}/topics`,
          classNames: {
            container: a.subMenuContainer,
            itemRow: a.offsetDropdownItemRow
          },
          isActive: i(
            "/topics"
            /* KNOWLEDGE_BASE */
          )
        }
      ) : null,
      p ? null : /* @__PURE__ */ t(
        L,
        {
          label: r("pages.about"),
          path: `/${e}/about/company`,
          hasShrunk: l,
          isActive: i(
            "/about/company"
            /* ABOUT_COMPANY */
          )
        }
      ),
      /* @__PURE__ */ t(
        S,
        {
          language: e,
          getTranslation: r,
          isScrolledHeader: l,
          isActive: i(
            "/for-lawyers/legal-network"
            /* FOR_LAWYERS */
          )
        }
      ),
      /* @__PURE__ */ t(
        C,
        {
          isScrolledHeader: l,
          isActive: i(
            "/account"
            /* ACCOUNT */
          ),
          isAuthenticated: s.isAuthenticated,
          userImage: s.userImage,
          openAuthModal: s.openAuthModal,
          logout: s.logout,
          hasNotifications: s.hasNotifications,
          language: e,
          getTranslation: r
        }
      )
    ] })
  ] }) }) });
};
export {
  Q as DesktopMenu
};
